module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/img01-d01f168422fcc2d0434d226c902a2208.png";